import { UserAccessHandler } from '@sennder/shell-utilities'
import { featureFlag } from '@/services/featureFlagProvider'

/**
 * Access handlers are functions which return a boolean. They can be used as menu visibility handlers, and called in route guards.
 *
 * NAMING CONVENTIONS
 *
 * Access handler name should be a sentence which describes what access it checks, or user role it checks.
 *
 * - userIs{Role}: Check if the user has a specific role
 * - canAccess{Page}: Check if the user has access to the page
 */

export const canAccessNewShipment: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('load-booking')

export const canAccessOpportunities: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('opportunities')

export const canAccessAnalytics: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('analytics')

export const canAccessMyAnalytics: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('my-analytics')

export const canAccessOperationsOverview: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('operations-dashboard')
